import { render } from "./slides_iframe_tc_01_secboot_signmodule.vue?vue&type=template&id=6cbf1dcf&scoped=true"
import script from "./slides_iframe_tc_01_secboot_signmodule.vue?vue&type=script&lang=js"
export * from "./slides_iframe_tc_01_secboot_signmodule.vue?vue&type=script&lang=js"

import "./slides_iframe_tc_01_secboot_signmodule.vue?vue&type=style&index=0&id=6cbf1dcf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cbf1dcf"]])

export default __exports__